module.exports = __webpack_public_path__ + "static/media/Signature.d9db7e20.jpg";